<template>
  <div>
    <!-- 列表页面 -->
    <div class="container">
      <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
          <i class="el-icon-s-fold" ></i>
          <el-breadcrumb separator="/" >
            <el-breadcrumb-item >系统服务</el-breadcrumb-item>
            <el-breadcrumb-item class="bread" :to="{ path: '/system/feedback' }">建议反馈</el-breadcrumb-item>
            <el-breadcrumb-item >全部反馈</el-breadcrumb-item>
          </el-breadcrumb>
      </div>

      <div class="user-info">
          <div>
            <div class="header-common">
              <div class="header-common-left">
                <div class="title">反馈列表信息</div>
              </div>
              <div class="header-common-right"></div>
            </div>
            <!-- 表格 -->
              <el-table
                v-loading='loading'
                :data="tableData"
                class="ones"
                :cell-style="tableCellStyle"
                :header-cell-style="tableHeaderCellStyle"
                :max-height="tableHeight"
                >
                <el-table-column
                  prop="time"
                  label="时间">
                </el-table-column>
                <el-table-column
                  prop="groupName"
                  label="分组名称">
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="账号名">
                </el-table-column>
                <el-table-column
                  prop="nickname"
                  label="真实姓名">
                </el-table-column>
                <el-table-column
                  prop="suggestion"
                  label="反馈内容">
                </el-table-column>
              </el-table>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        tableData: [],
        loading:false,
        tableHeight:0,
      }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      getData(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/system/suggestion/all';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.suggestions){
                this.tableData = obj.data.suggestions;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-220 < 300 ? 300 : window.innerHeight-220;
        })
      },
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)
      this.sizeFun()
      this.getData()
    },
    created() {
      
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    }

  }
</script>


<style lang="scss" scoped>
.container {
  height: 100%;
  margin-top: $header-height;

  .bread >>>.el-breadcrumb__inner{
    color: #606266;
    font-weight: 400;
  }

  .header-common{
    width: 100%;
    height: 45px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .header-common-left{

      font-size: 20px;

      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;
    }
  }

  .ones{
    width:100%;
    border: 1px solid rgba(45,65,91,0.35);
    // border-radius: 3px;
  }

  .user-info{
    border-radius: 12px;
    border: 2px solid #1A3F81;
    padding-bottom: 5px;
  }


  .action-button{
    width: 89px;
    height: 31px;
    background: linear-gradient(0deg, #CCCCCC, #FFFFFF);
    border: 1px solid rgba(49,48,48,0.55);
    border-radius: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #4F4F4F;
    // line-height: 26px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }


}
</style>



// WEBPACK FOOTER //
// src/view/system/feedback-list.vue